import { Suspense } from "react";
import { Navigate, Route, Routes, useLocation, useParams } from "react-router-dom";
import RootLayout from "./layouts/RootLayout";
import AuthPage from "./pages/AuthPage";
import OnboardingPage from "./pages/OnboardingPage";
import WorkspacePage from "./pages/WorkspacePage";
import MyCompanyPage from "./pages/MyCompanyPage";
import MyProfilePage from "./pages/MyProfilePage";
import TechnicianPage from "./pages/TechnicianPage";
import RemoteEstimateApprovalPage from "./pages/RemoteEstimateApprovalPage";
import EstimateApprovalChoicePage from "./pages/EstimateApprovalChoicePage";
import PublicMembershipRenewalPage from "./pages/PublicMembershipRenewalPage";
import { isFieldApp } from "./lib/field-app";

function CheckoutInvoiceReturn() {
  const { invoiceId } = useParams();
  const location = useLocation();
  const search = new URLSearchParams(location.search);
  if (invoiceId) search.set("invoice", invoiceId);
  return <Navigate to={`/dashboard?${search.toString()}`} replace />;
}

export default function App() {
  const location = useLocation();
  const fieldApp = isFieldApp(undefined, location.search);

  return (
    <Routes>
		<Route path="/estimate-approval/:token" element={<RemoteEstimateApprovalPage />} />
		<Route path="/estimate-approval-choice/:token" element={<EstimateApprovalChoicePage />} />
		<Route path="/membership-renewal/:token" element={<PublicMembershipRenewalPage />} />
      <Route element={<RootLayout />}>
        <Route index element={<Navigate to={fieldApp ? "/technician" : "/dashboard"} replace />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/auth/reset-password" element={<AuthPage />} />
        <Route path="/dashboard" element={fieldApp ? <Navigate to="/technician" replace /> : <WorkspacePage />} />
        <Route path="/jobs/:jobId" element={fieldApp ? <Navigate to="/technician" replace /> : <WorkspacePage />} />
        <Route path="/purchase-orders/:purchaseOrderId" element={fieldApp ? <Navigate to="/technician" replace /> : <WorkspacePage />} />
        <Route path="/technician" element={<TechnicianPage />} />
        <Route path="/technician/demo" element={<Navigate to="/technician" replace />} />
        <Route path="/mycompany" element={<MyCompanyPage />} />
        <Route path="/my-profile" element={<MyProfilePage />} />
        <Route path="/workspace/settings/payments" element={<MyCompanyPage />} />
        <Route path="/workspace/invoices/:invoiceId" element={<CheckoutInvoiceReturn />} />
        <Route path="/workview" element={<Navigate to="/dashboard" replace />} />
        <Route path="/onboarding" element={<Suspense fallback={<main className="flex min-h-[calc(100vh-73px)] items-center justify-center px-6 text-sm text-slate-500">Loading onboarding…</main>}><OnboardingPage /></Suspense>} />
        <Route
          path="/onboarding/company"
          element={<Navigate to="/onboarding" replace />}
        />
        <Route
          path="/onboarding/first-job"
          element={<Navigate to="/onboarding" replace />}
        />
      </Route>
    </Routes>
  );
}
